import { POSTAPI, generateHeader } from "../../../api-setup/api-helper";
import { SELECT_MOBILE_USER_DETAILS } from "../../../api-setup/api-endpoints";

export const fetchProviderId = async (cookiesData, dispatch) => {
  if (!cookiesData.secretToken) return null;

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_user_id: cookiesData.out_user_id,
      in_sort_number: 1,
      in_sort_order: "ASC",
    };

    const response = await POSTAPI(false, SELECT_MOBILE_USER_DETAILS, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.out_parameters) {
      const { out_ret_code, out_error_msg } = response.data.out_parameters;
      const rowResult = response.data.row_result;

      if (out_ret_code === 0) {
        if (rowResult && Array.isArray(rowResult) && rowResult.length > 0) {
          const providerIdFromAPI = rowResult[0].provider_mstr_key;
          return providerIdFromAPI;
        }
      } else {
        console.error("Error fetching provider id:", out_error_msg);
      }
    }
  } catch (error) {
    console.error("Error fetching provider id:", error);
  }
};
